import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Quote, Star, ArrowUpRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { getTestimonials } from "../lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getTestimonials().then(setItems).catch(() => {});
  }, []);

  return (
    <div className="pt-32 pb-24 min-h-screen" data-testid="testimonials-page">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] text-gold">Testimonials</span>
          <h1 className="font-serif text-5xl md:text-7xl font-light mt-4 leading-none text-foreground">
            Voices from the <span className="text-gradient-gold italic">people I've mentored.</span>
          </h1>
          <p className="mt-6 text-muted-foreground md:text-lg font-light max-w-2xl">
            From residents and founders to faculty and students — reflections on working together across research, writing and innovation.
          </p>
        </Reveal>

        <div className="mt-16 columns-1 md:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
          {items.map((t, i) => (
            <Reveal key={t.id} delay={(i % 3) * 0.06}>
              <div className="break-inside-avoid mb-6 rounded-2xl border border-gold/15 bg-card p-8" data-testid={`testimonial-${t.id}`}>
                <div className="flex items-center gap-1 mb-5">
                  {Array.from({ length: t.rating || 5 }).map((_, k) => (
                    <Star key={k} size={15} className="text-gold fill-gold" />
                  ))}
                </div>
                <Quote className="text-gold/30 mb-4" size={30} />
                <p className="font-serif text-xl md:text-2xl text-foreground/90 leading-relaxed italic">
                  "{t.quote}"
                </p>
                <div className="mt-7 pt-5 border-t border-gold/10 flex items-center gap-3">
                  <span className="w-11 h-11 rounded-full bg-gradient-to-br from-gold to-royal flex items-center justify-center text-ink font-serif text-lg">
                    {t.name?.charAt(0)}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground">{t.name}</p>
                    <p className="text-xs text-muted-foreground">{t.role} · {t.org}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-16 rounded-3xl border border-royal/25 bg-[radial-gradient(ellipse_at_center,rgba(147,51,234,0.12),transparent_65%)] p-12 text-center">
            <h2 className="font-serif text-3xl md:text-4xl text-foreground">Ready to be the next success story?</h2>
            <Link to="/book" data-testid="testimonials-book-btn"
              className="mt-8 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gold text-ink text-sm uppercase tracking-[0.12em] font-semibold hover:bg-gold-light transition-colors">
              Book a Consultation <ArrowUpRight size={18} />
            </Link>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
